import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { isFieldRequired } from 'utils/helpers/formValidations';
import { IOptionProps } from './types';

interface IFormCheckProps {
  type?: 'radio' | 'checkbox' | 'switch';
  option: IOptionProps;
  isRequired?: boolean;
  disabled?: boolean;
}

/*
 * Abstracted form check component, displaying radio or checkbox controls.
 * It serves different layout based on props.
 */
const FormCheck: FC<IFormCheckProps> = ({ type, option, isRequired, disabled }) => {
  const { register } = useFormContext<any>();
  const { t } = useTranslation();
  return (
    <Form.Check
      custom
      type={type}
      label={option.label}
      id={option.id}
      value={option.value}
      {...register(option.name, {
        required: isFieldRequired(t, isRequired),
      })}
      disabled={disabled}
    />
  );
};

export default FormCheck;
